import { useEffect, useState } from 'react';
import { getTaskStyling } from '../utils/taskStatusUtils';

/**
 * Custom hook for managing task styling based on status and dates
 * @param {Object} taskData - Task data object
 * @returns {Object} Task styling colors
 */
export function useTaskStyling(taskData) {
  const [backgroundTask, setBackgroundTask] = useState('#fff');
  const [borderColorTask, setBorderColorTask] = useState('#000');

  useEffect(() => {
    if (!taskData) {
      setBackgroundTask('#fff');
      setBorderColorTask('#000');
      return;
    }

    const styling = getTaskStyling(taskData);
    setBackgroundTask(styling.backgroundTask);
    setBorderColorTask(styling.borderColorTask);
  }, [taskData]);

  return {
    backgroundTask,
    borderColorTask,
  };
}